import {Component, Input, OnInit} from '@angular/core';
import { WindowRef } from '@progress/kendo-angular-dialog';
import {PatientSearchUtil} from "../../utilities/patient-search.util";
import {RowArgs} from "@progress/kendo-angular-grid";
import {DocumentUtil} from "../../utilities/document.util";
import {Subscription} from "rxjs";
import {LoaderService} from "../../../core/services/loader.service";
import {showNotification} from "../../utilities/notificaton.util";

@Component({
    selector: 'app-patient-matches',
    templateUrl: './patient-matches.component.html',
    styleUrls: ['./patient-matches.component.scss'],
    standalone: false
})
export class PatientMatchesComponent implements OnInit {
  public downloading: Subscription;
  protected readonly PatientSearchUtil = PatientSearchUtil;
  @Input() public matches: any;
  @Input() public patientSearch: any;
  constructor(private windowRef: WindowRef, private formUtils: DocumentUtil, protected loader: LoaderService) {}

  ngOnInit(): void {
    this.matches.forEach((m: any) => {
      console.log(m);
      m.forms = this.setPatientFormsData(m);
    });
  }
  public setPatientFormsData(m: any) {
    let patientFormsTables = [];
    if (m.form !== undefined) {
      const polst = {id: m.form.id, is_form: true, is_latest: false, type: 'POLST', current: m.form.current, doc_date: m.form.created};
      patientFormsTables.push(polst);
    }
    if (m.latestPolstRejected !== undefined) {
      const polst = {id: m.latestPolstRejected.id, is_form: false, is_latest: true, type: 'POLST', current: false, doc_date: m.latestPolstRejected.created};
      patientFormsTables.push(polst);
    }
    m.advanceDirectives.forEach((ad: any) => {
      const adForm = {id: ad.id, is_form: false, is_latest: false, type: 'Advance Directive', current: ad.current, doc_date: ad.doc_date};
      patientFormsTables.push(adForm);
    });
    return patientFormsTables;
  }
  public columnColor(form: any): string {
    let color = '';
    if (form.is_form) {
      color = "#198754"; // Published
    }
    if (form.is_latest) {
      color = "#fff9c4"; // Latest Rejected
    }
    return color;
  }
  public select(selectionType: any, patient: any) {
    if (selectionType === 'create_new') {
      this.windowRef.close({matched: false, patient: null, hasDifference: false});
    } else {
      this.windowRef.close({matched: true, patient, hasDifference: this.checkPatientDifferences(patient)});
    }
  }
  public checkPatientDifferences(pt: any): any {
    let classStrings = [];
    classStrings.push(PatientSearchUtil.compareStrings(pt.fname, this.patientSearch.fname, false));
    classStrings.push(PatientSearchUtil.compareStrings(pt.mname, this.patientSearch.mname, false));
    classStrings.push(PatientSearchUtil.compareStrings(pt.lname, this.patientSearch.lname, false));
    classStrings.push(PatientSearchUtil.compareStrings(pt.suffix, this.patientSearch.suffix, false));
    classStrings.push(PatientSearchUtil.compareStrings(pt.dob, this.patientSearch.dob, true));
    classStrings.push(PatientSearchUtil.compareStrings(pt.gender, this.patientSearch.gender, false));
    classStrings.push(PatientSearchUtil.compareStrings(pt.street, this.patientSearch.street, false));
    classStrings.push(PatientSearchUtil.compareStrings(pt.city, this.patientSearch.state, false));
    classStrings.push(PatientSearchUtil.compareStrings(pt.zip, this.patientSearch.zip, false));
    return classStrings.some(item => item === 'mismatch');
  }
  public expandDetails(): boolean {
    return true;
  }
  async viewForm(form) {
    let blob;
    this.loader.show('Downloading ...');
    try {
      if (form.type === 'POLST') {
        blob = await this.formUtils.downloadPolst(form.id, form.organizationID);
        DocumentUtil.openNewTab(blob);
      } else {
        blob = await this.formUtils.downloadAd(form.id);
        DocumentUtil.openNewTab(blob);
      }
    } catch (err) {
      // showNotification('An Error Occurred', 'error', this.noti)
    } finally {
      this.loader.hide();
    }
  }
}
